<template>
    <div class="dhivehi">
        <div
            :id="rootId"
            :style="`height: ${height ? height + 'px' : '500px'}`"
        ></div>
    </div>
</template>

<script>
import am5 from './am5'
import * as am5percent from '@amcharts/amcharts5/percent'
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated'

export default {
    props: [
        'height',
        'data',
        'valueField',
        'categoryField',
        'showLabels',
    ],
    data() {
        return {
            rootId: null,
            root: null,
        }
    },
    watch: {
        data() {
            this.root?.dispose()
            this.root = am5.Root.new(this.rootId)
            this.draw()
        },
    },
    methods: {
        draw() {
            // Set themes
            // https://www.amcharts.com/docs/v5/concepts/themes/
            this.root.setThemes([am5themes_Animated.new(this.root)])

            // Create chart
            // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/
            var chart = this.root.container.children.push(
                am5percent.PieChart.new(this.root, {
                    layout: this.root.verticalLayout,
                    innerRadius: am5.percent(50),
                })
            )

            // Create series
            // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Series
            var series = chart.series.push(
                am5percent.PieSeries.new(this.root, {
                    // valueField: 'value',
                    // categoryField: 'category',
                    valueField: this.valueField,
                    categoryField: this.categoryField,
                    alignLabels: false,
                })
            )

            // show labeld on chart
            if (this.showLabels) {
                series.labels.template.setAll({
                    textType: 'circular',
                    centerX: 0,
                    centerY: 0,
                })
            } else {
                series.labels.template.setAll({
                    forceHidden: true,
                })
                series.ticks.template.setAll({
                    forceHidden: true,
                })
            }

            // Set data
            // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Setting_data
            series.data.setAll(
                // [
                //     { value: 10, category: 'One' },
                //     { value: 9, category: 'Two' },
                //     { value: 6, category: 'Three' },
                //     { value: 5, category: 'Four' },
                //     { value: 4, category: 'Five' },
                //     { value: 3, category: 'Six' },
                //     { value: 1, category: 'Seven' },
                // ]
                this.data
            )

            // Create legend
            // https://www.amcharts.com/docs/v5/charts/percent-charts/legend-percent-series/
            var legend = chart.children.push(
                am5.Legend.new(this.root, {
                    centerX: am5.percent(50),
                    x: am5.percent(50),
                    marginTop: 15,
                    marginBottom: 15,
                })
            )

            legend.data.setAll(series.dataItems)

            // Play initial series animation
            // https://www.amcharts.com/docs/v5/concepts/animations/#Animation_of_series
            series.appear(1000, 100)
        },

        randomString() {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
            let result = ''
            for (let i = 0; i < 10; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length))
            }
            return result
        },
    },

    mounted() {
        this.root = am5.Root.new(this.rootId)
        this.draw()
    },

    created() {
        this.rootId = am5.randomString()
    },
}
</script>


<style scoped>
</style>